import {useMemo,useState} from 'react';
import {calendarSourceDefaults} from '../Calendar/calendarSources';

const preferenceKey=uid=>`overview.calendarSources.v1.${uid}`;
function readSelection(uid) {
  if(uid)try {
    const saved=JSON.parse(localStorage.getItem(preferenceKey(uid))||'null');
    if(saved&&typeof saved.personal==='boolean'&&typeof saved.defaultTeams==='boolean'&&saved.teams&&typeof saved.teams==='object'&&!Array.isArray(saved.teams)) {
      return {...saved,teams:Object.fromEntries(Object.entries(saved.teams).filter(([,value])=>typeof value==='boolean'))};
    }
  }catch{/* Storage may be unavailable; all calendars remain the first-use default. */}
  return calendarSourceDefaults('all');
}

export default function useOverviewCalendars(uid) {
  const [preference,setPreference]=useState(null);
  const selection=useMemo(()=>preference&&preference.owner===uid?preference.value:readSelection(uid),[preference,uid]);
  function change(value) {
    if(!uid)return;
    setPreference({owner:uid,value});
    try{localStorage.setItem(preferenceKey(uid),JSON.stringify(value));}catch{/* Keep working in memory. */}
  }
  return [selection,change];
}
